import { apiRequest } from '../api/request';

export interface MenuItem {
  pk_id: string;
  restaurant_id: string;
  restaurant_parent_id: string;
  sku_id: string;
  name: string;
  price: string;
  indining_price: string;
  is_enabled: boolean;
  product_description: string;
  inventory_status: boolean;
  is_item_verified: boolean;
  account_id: string;
  [key: string]: any; // Allow for additional dynamic fields
}

export interface GetMenuResponse {
  data: MenuItem[];
}

export const menuService = {
  getMenu: async (apiBaseUrl: string, restaurantId: string, accountId: string, type?: string): Promise<GetMenuResponse> => {
    if (!restaurantId) {
      throw new Error('No restaurant ID available');
    }
    
    if (!accountId) {
      throw new Error('No account ID available');
    }
    
    const params = new URLSearchParams();
    if (type) {
      params.append('type', type);
    }
    // Add includeModifiers parameter to get full modifier data
    params.append('includeModifiers', 'true');
    
    const queryString = params.toString();
    const endpoint = `/menu?${queryString}`;
    
    const response = await fetch(`${apiBaseUrl}${endpoint}`, {
      method: 'GET',
      headers: {
        'API-Key': accountId,
        'restaurant-id': restaurantId,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch menu');
    }

    const data = await response.json();
    
    // The API returns the array directly, not wrapped in {data: []}
    // So we need to wrap it to match our interface
    return { data: Array.isArray(data) ? data : [] };
  },
};
